var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolePermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M798.6 321.4c-0.2-122.8-87.3-228.2-207.9-251.5C470.3 46.5 350.1 111.7 304 225.5s-5.1 244.3 97.7 311.3c2.1 1.2 3.5 3.4 3.5 5.9 0 2.4-1.3 4.7-3.5 5.9-74.7 27.2-140.1 75.3-188.2 138.6-53.4 70.5-82.2 156.5-81.9 244.9 0 15.5 12.6 28.1 28.1 28.1 15.5 0 28.1-12.6 28.1-28.1-0.5-194.4 156.5-352.6 351-353.5h5.3c140.5-2.3 253.3-116.5 253.9-257l0.6-0.2zM542.2 522.5c-95.5 0.6-178.1-66.5-197.2-160.1-19.1-93.6 30.7-187.7 118.9-224.5 88.1-36.8 190-6.2 243.3 73.1 53.2 79.3 42.9 185.2-24.6 252.8-37.2 37.5-87.7 58.6-140.4 58.7z m361.9 226.4H878v-60.6c1.9-34-15.2-66.3-44.4-83.9a91.884 91.884 0 0 0-94.9 0c-29.2 17.6-46.3 49.9-44.4 83.9v60.6h-26.1c-12.6 0-22.7 10.2-22.7 22.7v165.8c0 12.6 10.2 22.7 22.7 22.7h235.9c12.5 0 22.7-10.2 22.7-22.7V771.6c0-12.5-10.1-22.7-22.7-22.7z m-101.5 117v46.6c0 1-0.4 2-1.2 2.8-0.7 0.7-1.7 1.2-2.8 1.2h-24.1c-1 0-2-0.4-2.8-1.2-0.7-0.7-1.1-1.7-1.1-2.8v-46.6c-15.1-7.6-23-24.6-19.1-41 3.9-16.4 18.6-28 35.5-28s31.6 11.6 35.5 28c3.9 16.4-4 33.4-19.1 41h-0.8z m40.1-117H730.5V690c0-31 25.1-56.1 56.1-56.1s56.1 25.1 56.1 56.1v58.9z m0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolePermissions);
export default __webpack_public_path__ + "static/media/role-permissions.d9f3614055c8358606ae5ce41f8d5e78.svg";
export { ForwardRef as ReactComponent };